import { ContentResponse } from "authory-api-types/dist/types";
import { ItemMetadata } from "../V3ProfileListItem";
import { V3CNWrapper } from "./V3ContentNavbar.styles";

export const V3ContentNavbar: React.FC<React.PropsWithChildren<{
    content: ContentResponse,
    isBusinessParent?: boolean,
    isPrivateView: boolean,
    viewOriginal?: boolean,
}>> = ({ content, children, isBusinessParent = false, isPrivateView, viewOriginal = false }) => <V3CNWrapper $isPrivateView={isPrivateView}>
    <div>
        <ItemMetadata
            item={content}
            showRedirect={false}
            isB2B={isBusinessParent}
            viewOriginal={viewOriginal}
        />
    </div>
    <div>
        {children}
    </div>
</V3CNWrapper>